export default __webpack_public_path__ + "static/media/active_status_active.7fc9f00d.svg";